import { render } from "./OldSingleFileUploadTemplate.vue?vue&type=template&id=3a568297"
import script from "./OldSingleFileUploadTemplate.vue?vue&type=script&lang=js"
export * from "./OldSingleFileUploadTemplate.vue?vue&type=script&lang=js"

import "./OldSingleFileUploadTemplate.vue?vue&type=style&index=0&id=3a568297&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__